<template>
  <div>
    <b-card>
      <b-form class="custom-form" @submit.prevent="submitForm">
        <b-row>
          <b-col md="12">
            <h3>{{ isEditMode ? 'Editar' : 'Criar' }} Instância SigaWeb</h3>
          </b-col>

          <b-col md="6">
            <div class="form-label-group">
              <b-form-input
                id="name"
                placeholder="Nome"
                v-model="form.name"
                required
              />
              <label for="name">Nome *</label>
            </div>
          </b-col>

          <b-col md="6">
            <div class="form-label-group">
              <b-form-input
                id="priority"
                placeholder="Prioridade"
                v-model.number="form.priority"
                type="number"
                min="1"
                required
              />
              <label for="priority">Prioridade *</label>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-label-group">
              <b-form-input
                id="url"
                placeholder="URL"
                v-model="form.url"
                required
              />
              <label for="url">URL *</label>
            </div>
          </b-col>

          <b-col md="6">
            <div class="form-label-group">
              <b-form-input
                id="user"
                placeholder="Usuário"
                v-model="form.user"
                required
              />
              <label for="user">Usuário *</label>
            </div>
          </b-col>

          <b-col md="6">
            <div class="form-label-group">
              <b-form-input
                id="pass"
                placeholder="Senha"
                v-model="form.pass"
                type="password"
                required
              />
              <label for="pass">Senha *</label>
            </div>
          </b-col>

          <b-col md="12">
            <div class="form-label-group">
              <b-form-checkbox
                id="active"
                v-model="form.active"
              >
                Ativo
              </b-form-checkbox>
            </div>
          </b-col>

          <b-col v-if="isEditMode" md="6">
            <div class="form-label-group">
              <b-form-input
                id="dt-created"
                placeholder="Data Criação"
                v-model="form.dt_create"
                disabled
              />
              <label for="dt-created">Data Criação</label>
            </div>
          </b-col>

          <b-col md="12"><hr /></b-col>

          <b-col md="12">
            <b-button variant="primary" type="submit" :disabled="formSubmitting">
              <b-spinner small v-if="formSubmitting"></b-spinner>
              {{ isEditMode ? 'Atualizar' : 'Criar' }}
            </b-button>
            <b-button variant="outline-secondary" @click="goBack" class="ml-2">
              Voltar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard, BForm, BRow, BCol, BFormInput, BFormCheckbox, BSpinner } from "bootstrap-vue";
import sigaInstanceService from "@/providers/sigaInstanceService";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  components: {
    BButton,
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BSpinner,
  },
  data() {
    return {
      form: {
        _id: null,
        name: '',
        url: '',
        user: '',
        pass: '',
        priority: null,
        active: true,
        dt_create: null,
      },
      isEditMode: false,
      formSubmitting: false,
    };
  },
  computed: {
    pageTitle() {
      return this.isEditMode ? 'Editar Instância SigaWeb' : 'Criar Instância SigaWeb';
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      this.loadData();
    }
  },
  methods: {
    loadData() {
      sigaInstanceService.getSigaInstanceDetails(this.$route.params.id)
        .then(response => {
          this.form = response;
        })
        .catch(error => {
          messagesNotifyHelper.showMessageNotifyError(this, error);
          this.goBack();
        });
    },
    submitForm() {
      if (!this.form.name || !this.form.url || !this.form.user || !this.form.pass || !this.form.priority) {
        messagesNotifyHelper.showMessageNotifyError(this, 'Preencha todos os campos obrigatórios');
        return;
      }

      this.formSubmitting = true;
      sigaInstanceService.registerSigaInstance(this.form)
        .then(() => {
          const message = this.isEditMode ? 'Instância atualizada com sucesso' : 'Instância criada com sucesso';
          messagesNotifyHelper.showMessageNotifySuccess(this, message);
          this.goBack();
        })
        .catch(error => {
          messagesNotifyHelper.showMessageNotifyError(this, error);
        })
        .finally(() => {
          this.formSubmitting = false;
        });
    },
    goBack() {
      this.$router.push({ name: 'admin-siga-instance-list' });
    },
  },
};
</script>
